export default __webpack_public_path__ + "assets/static/data/code-gen-data.51923fed137fcfc2470a53cf4d9efc1b.json";